import { useChatRoomStoreStates } from "@circle-react/hooks/chatsV2/store";
import { useChatMessagesV2Api } from "@circle-react/hooks/chatsV2/useChatMessagesV2Api";
import { TwoWayPagination } from "@circle-react-shared/Pagination/TwoWayPagination";

interface ChatRoomBodyProps {
  children: React.ReactNode;
  componentId?: string;
  isFirstPage: boolean;
  isLastPage: boolean;
  setIsFirstPage: (isFirstPage: boolean) => void;
  setIsLastPage: (isLastPage: boolean) => void;
}

export const ChatRoomBody = ({
  children,
  isLastPage,
  isFirstPage,
  setIsFirstPage,
  setIsLastPage,
  componentId = "message-scroll-view",
}: ChatRoomBodyProps) => {
  const { fetchChatMessages } = useChatMessagesV2Api();

  const {
    hasNextPage,
    hasPrevPage,
    isLoading: isChatMessagesLoading,
    firstMessageId,
    lastMessageId,
  } = useChatRoomStoreStates();

  return (
    <div className="flex h-auto grow flex-col overflow-auto">
      <TwoWayPagination
        shouldShowPrevLoader={!isLastPage}
        shouldShowNextLoader={!isFirstPage}
        hasNextPage={hasNextPage}
        hasPrevPage={hasPrevPage}
        onNextPage={messageId => {
          void fetchChatMessages({
            id: messageId,
            previousPerPage: 0,
            nextPerPage: 20,
            parentMessageId: null,
          });
          setIsFirstPage(false);
        }}
        onPrevPage={messageId => {
          void fetchChatMessages({
            id: messageId,
            parentMessageId: null,
          });
          setIsLastPage(false);
        }}
        firstItemId={firstMessageId}
        lastItemId={lastMessageId}
        componentId={componentId}
        isLoading={isChatMessagesLoading}
      >
        {children}
      </TwoWayPagination>
    </div>
  );
};
